// extracted by mini-css-extract-plugin
export default {"box":"inventorySparesLotListPage_box__Xi01q"};